import React, { useEffect, useRef } from "react";
import { Table, Alert, Spinner, Button, Row, Col } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";
import { FormattedDate, FormattedTime } from "react-intl";
import Pager from 'common/components/Pager';
import FormattedDuration from "react-intl-formatted-duration";
import FleetDropdownFilter from "pages/dashboard/components/FleetDropdownFilter";
import Search from "pages/dashboard/components/Search";
import SessionDetailModal from "pages/dashboard/components/SessionDetailModal";

const SessionsHistory = props => {

    const [state, setState] = useSuperState({
        error: null,
        loading: true,
        sessions: null,
        page: 1,
        page_size: 20,
        count: 0,
        appstream_fleet_name: '',
        search: ''
    });

    const { api } = useApp();
    const session_detail_ref = useRef(null);

    const { error, loading, sessions, page, page_size, count, appstream_fleet_name, search } = state;

    const refreshSessions = async () => {

        setState({
            loading: true
        });

        await api.get(`/api/appstream/sessions/history/list/${page}/${page_size}`, { appstream_fleet_name, search }).then(({ sessions, count }) => {

            setState({
                sessions,
                count,
                loading: false
            });

        }).catch(e => {
            setState({ error: e?.err || e.toString() });
        });

    };

    const handleViewDetails = session => session_detail_ref.current.show(session);

    const handleChangePage = page => setState({ page, sessions: [] });

    useEffect(() => {

        refreshSessions();

    }, []);

    useEffect(() => {

        refreshSessions();

    }, [state.page, appstream_fleet_name, search]);

    return (
        <>

            {error && <Alert variant="warning">{error}</Alert>}
            {loading &&
            <div className="text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
            }
            {!loading && !error &&
            <>
                <Row>
                    <Col md={6} lg={3} className="mb-sm-2 mb-md-0 mb-2">
                        <Search onChange={val => setState({ search: val })} defaultValue={search} />
                    </Col>
                    <Col md={6} lg={3}>
                        <FleetDropdownFilter onChange={appstream_fleet_name => setState({ appstream_fleet_name })} value={appstream_fleet_name}/>
                    </Col>
                </Row>
                <hr/>
                <Table className="m-0 mb-2" borderless striped responsive>
                    <thead>
                        <tr>
                            <th>SMS User</th>
                            <th>AppStream User</th>
                            <th>Product</th>
                            <th>Duration</th>
                            <th>Start Time</th>
                            <th>Last Activity</th>
                            <th className="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions && sessions.map(session => {

                                        const { appstream_user_id, sms_user_name, sms_practice_test_result_id, started_at, last_active, duration_seconds, sms_application_name } = session;

                                        return (
                                            <>
                                                <tr>
                                                    <td className="align-middle">
                                                        {!!sms_user_name ? sms_user_name : <i>Not provided</i>}
                                                    </td>
                                                    <td className="align-middle">
                                                        {appstream_user_id}
                                                    </td>
                                                    <td className="align-middle">
                                                        {sms_application_name}
                                                    </td>
                                                    <td className="align-middle">
                                                        <FormattedDuration seconds={duration_seconds} unitDisplay="short" format="{minutes} {seconds}" />
                                                    </td>
                                                    <td className="align-middle">
                                                        <FormattedDate value={started_at}/>
                                                        &nbsp;
                                                        <FormattedTime value={started_at}/>
                                                    </td>
                                                    <td className="align-middle">
                                                        {!!last_active && <>
                                                            <FormattedDate value={last_active}/>
                                                            &nbsp;
                                                            <FormattedTime value={last_active}/>
                                                        </>}
                                                        {!last_active && "-"}
                                                    </td>
                                                    <td className="align-middle text-end">

                                                        <Button
                                                            size="sm"
                                                            variant="outline-secondary"
                                                            onClick={() => handleViewDetails(session)}
                                                        >
                                                            Details
                                                        </Button>

                                                    </td>
                                                </tr>
                                            </>
                                        );

                                    })}
                        {!sessions?.length && <tr>
                            <td colSpan={7} className="text-center">No active sessions</td>
                        </tr>}
                    </tbody>
                </Table>
                <Pager page={page} count={count} page_size={page_size} onChange={handleChangePage}/>

            </>
            }

            <SessionDetailModal ref={session_detail_ref}/>
        </>
    );
};

export default SessionsHistory;
